import React from 'react'
import { Skeleton, SkeletonParagraph } from '@node-space/storybook-components/dist/SkeletonLoader'
import { Box } from '@node-space/ui-components'

export interface PageSkeletonLoaderProps {
  showCancel?: boolean
}

export const PageSkeletonLoader = ({ showCancel }: PageSkeletonLoaderProps) => {
  return (
    <>
      <SkeletonParagraph />
      <Box
        flexCol
        justify={showCancel ? 'between' : 'center'}
        gap={8}
        gapX={8}
        gapY={24}
        className="sm:flex-row"
      >
        {[...Array(showCancel ? 2 : 1)]?.map((row, index) => (
          <Skeleton
            key={`form button ${index}`}
            variant="button"
            className="w-full sm:max-w-[318px]"
          />
        ))}
      </Box>
    </>
  )
}
